import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import metadata from './marketingPageMetadata.json';
const aliases = { '/pricing': '/select-plan', '/features': '/product/features', '/about-us': '/about', '/privacy-policy': '/privacy', '/terms-of-service': '/terms', '/pitch': '/product/overview', '/salesbrief': '/product/overview', '/resources/problem-outcomes': '/product/overview', '/integrations': '/product/how-it-works', '/join': '/signup', '/use-cases/agencies': '/use-cases/professional-services', '/use-cases/finance-ops': '/solutions/finance-team', '/request-password-reset': '/account/recovery', '/reset-password': '/account/recovery' };
export default function MarketingMetadata() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const canonical = aliases[pathname] || pathname;
    const entry = metadata[canonical] || { title: 'FinnixPro | Account & public information', description: 'Financial intelligence for project-driven businesses.' };
    document.title = entry.title;
    const setMeta = (key, value, property = false) => {
      const attr = property ? 'property' : 'name';
      let node = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!node) { node = document.createElement('meta'); node.setAttribute(attr, key); document.head.appendChild(node); }
      node.content = value;
    };
    setMeta('description', entry.description);
    setMeta('og:title', entry.title, true); setMeta('og:description', entry.description, true);
    setMeta('og:url', `https://www.finnixpro.com${canonical}`, true);
    setMeta('twitter:title', entry.title); setMeta('twitter:description', entry.description);
    const noindex = !metadata[canonical] || ['/signup', '/login', '/account/recovery', '/advisory', '/resources/advisors', '/use-cases/construction'].includes(canonical);
    setMeta('robots', noindex ? 'noindex,follow' : 'index,follow');
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = `https://www.finnixpro.com${canonical}`;
    window.scrollTo(0, 0);
    // Lazy route content can mount after metadata; observe until an in-page target exists.
    if (!hash) return undefined;
    const scroll = () => { const node = document.getElementById(decodeURIComponent(hash.slice(1))); if (node) { node.scrollIntoView(); return true; } return false; };
    if (scroll()) return undefined;
    const observer = new MutationObserver(() => { if (scroll()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [pathname, hash]);
  return null;
}
